"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinoutComparison = exports.SignalPinsRowSchema = void 0;
exports.splitPinList = splitPinList;
exports.joinPinList = joinPinList;
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
const pin_id_normalization_1 = require("./pin-id-normalization");
exports.SignalPinsRowSchema = z.object({
    signalName: z.string(),
    pins: z.string(),
});
function comparePinsNaturally(a, b) {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}
function canonicalPins(pins) {
    return pins.map((pin) => (0, pin_id_normalization_1.normalizePinIdForComparison)(pin)).sort(comparePinsNaturally);
}
function splitPinList(pins) {
    return canonicalPins(pins
        .split(/[\s,]+/)
        .map((entry) => entry.trim())
        .filter((entry) => entry !== ''));
}
function joinPinList(pins) {
    return canonicalPins(pins).join(', ');
}
class PinoutComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['signalName'], ['pins']);
        this.membershipScopeColumns = ['signalName'];
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'signalName' && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        if (column === 'pins' && typeof value === 'string') {
            return JSON.stringify(splitPinList(value));
        }
        return super.normalize(column, value, row);
    }
}
exports.PinoutComparison = PinoutComparison;
//# sourceMappingURL=pinout.comparison.js.map